module.exports = __webpack_public_path__ + "static/media/Fone.8cf75b18.svg";